/**
 * Sub-collection navigation on collection & brand pages.
 * Manages the horizontal scroll affordance (edge fades) and centres the
 * active tab into view on load. Markup is rendered server-side in
 * sections/main-collection-product-grid.liquid.
 */
class FeatCollectionsNav extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[feat-collections-scroller]');
    if (!this.scroller) return;

    this.updateAffordance = this.updateAffordance.bind(this);
    this.scroller.addEventListener('scroll', this.updateAffordance, { passive: true });
    window.addEventListener('resize', this.updateAffordance, { passive: true });

    this.scrollActiveIntoView();
    this.updateAffordance();
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.updateAffordance);
    window.removeEventListener('resize', this.updateAffordance);
  }

  scrollActiveIntoView() {
    const active = this.querySelector('[feat-collections-active]');
    if (!active) return;

    const offset = active.offsetLeft - (this.scroller.clientWidth - active.clientWidth) / 2;
    this.scroller.scrollLeft = Math.max(0, offset);
  }

  updateAffordance() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
    const maxScroll = scrollWidth - clientWidth;

    this.classList.toggle('collection-listing__feat-collections--scrollable', maxScroll > 1);
    this.classList.toggle('collection-listing__feat-collections--at-start', scrollLeft <= 1);
    this.classList.toggle('collection-listing__feat-collections--at-end', scrollLeft >= maxScroll - 1);
  }
}

if (!customElements.get('feat-collections-nav')) {
  customElements.define('feat-collections-nav', FeatCollectionsNav);
}
